module.exports = __webpack_public_path__ + "img/16_88.ccf63703.png";